import React from 'react';
import { Box, Button, CircularProgress, FormControl, MenuItem, Select, Typography } from '@mui/material';
import { getCurrentTerms } from '../../../../shared/projectTypeUtils';
import { isReadOnly } from '../../../../utils/permissionUtils';

const LockUnlockRightPanel = ({
    isSvg = false,
    selectedTrackerRows = [],
    onLockSelected,
    onUnlockSelected,
    active,
    setActive,
    scope,
    setScope,
    buttonLoading = { lock: false, unlock: false }
}) => {
    const TERMS = getCurrentTerms()
    const SCOPE_MODULES = [
        { value: 'piers', label: 'Piers' },
        { value: 'structure', label: 'Structure' },
        { value: 'module', label: 'Module' }
    ];
    const VISIBILITY_MODULES = [
        { value: 'external', label: 'External' },
        { value: 'internal', label: 'Internal' },
    ]

    const hasSelection = selectedTrackerRows.length > 0;
    const selectionCount = selectedTrackerRows.length;

    return (
        <Box p={2}>
            <FormControl size="small" fullWidth sx={{ mb: 2 }}>
                <Typography fontWeight={600} mb={1} sx={{ fontSize: "18px" }}>Visibility</Typography>
                <Select
                    value={active}
                    onChange={(e) => setActive(e.target.value)}
                    displayEmpty
                    disabled={isSvg || isReadOnly()}
                >
                    <MenuItem value="" disabled>
                        Select Visibility
                    </MenuItem>
                    {VISIBILITY_MODULES.map((option) => (
                        <MenuItem key={option.value} value={option.value}>
                            {option.label}
                        </MenuItem>
                    ))}
                </Select>
            </FormControl>

            {/* Scope Selector */}
            <FormControl size="small" fullWidth sx={{ mb: 2 }}>
                <Typography fontWeight={600} mb={1} sx={{ fontSize: "18px" }}>Scope</Typography>
                <Select
                    value={scope}
                    onChange={(e) => setScope(e.target.value)}
                    displayEmpty
                    disabled={isSvg || isReadOnly()}
                >
                    <MenuItem value="" disabled>
                        Select Scope
                    </MenuItem>
                    {SCOPE_MODULES.map((option) => (
                        <MenuItem key={option.value} value={option.value}>
                            {option.label}
                        </MenuItem>
                    ))}
                </Select>
            </FormControl>
            {/* Lock/Unlock Action Buttons */}
            <Box sx={{ display: "flex", gap: 2 }}>
                <Button
                    variant="contained"
                    onClick={onLockSelected}
                    disabled={(!hasSelection && isSvg) || isReadOnly()}
                    sx={{
                        flex: 1,
                        backgroundColor: hasSelection ? '#f16253' : '#ccc',
                        '&:hover': {
                            backgroundColor: hasSelection ? '#d9493a' : '#ccc'
                        },
                        fontWeight: 600
                    }}
                >
                    {buttonLoading.lock ? (
                        <CircularProgress size={24} color="inherit" />
                    ) : (
                        `Lock Selected ${TERMS.TRACKER_LABEL}${selectionCount > 1 ? 's' : ''}`
                    )}
                </Button>
                <Button
                    variant="contained"
                    onClick={onUnlockSelected}
                    disabled={(!hasSelection && isSvg) || isReadOnly()}
                    sx={{
                        flex: 1,
                        backgroundColor: hasSelection ? '#f16253' : '#ccc',
                        '&:hover': {
                            backgroundColor: hasSelection ? '#d9493a' : '#ccc'
                        },
                        fontWeight: 600
                    }}
                >
                    {buttonLoading.unlock ? (
                        <CircularProgress size={24} color="inherit" />
                    ) : (
                        `Unlock Selected ${TERMS.TRACKER_LABEL}${selectionCount > 1 ? 's' : ''}`
                    )}
                </Button>
            </Box>
        </Box>
    );
};

export default LockUnlockRightPanel;